import { useContext } from 'react';
import AuthenticationContext from 'contexts/authentication.context';

export default function useAuthentication() {
  const {user, getDataAccount, socket, statusSocket} = useContext(AuthenticationContext);

  const isAuthenticated = () => {
    return user !== undefined ? user !== null : undefined;
  }

  const signOut = async () => {
    return true;
  }

  return {
    user,
    signOut,
    isAuthenticated,
    reload: getDataAccount,
    socket,
    statusSocket
  };
}